module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_7.d41c6877.png";